import { jsx, jsxs } from "react/jsx-runtime";
import { MediaObject, Paragraph, Box, IconClockOutline } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { getReadTimeWithDefault } from "../../utils/getReadTimeWithDefault.esm.js";
const PostReadTime = ({
  readTime
}) => {
  const postReadTimeIcon = /* @__PURE__ */ jsx(Box, { as: IconClockOutline, sx: {
    display: "block"
  }, size: "xs", fontColor: "textMedium" });
  return /* @__PURE__ */ jsx(MediaObject, { media: postReadTimeIcon, align: "center", gutter: "xxs", children: /* @__PURE__ */ jsxs(Paragraph, { fontType: "bodySmall", fontColor: "textMedium", children: [
    getReadTimeWithDefault(readTime),
    " min read"
  ] }) });
};
PostReadTime.propTypes = {
  readTime: PropTypes.number
};
export {
  PostReadTime as default
};
